import * as actionTypes from "../constants/actionTypes";
import * as types from "../constants/componentTypes";

const initialState = {
    tickets: [],
    ticketsCount: 0,
    newTicketsCount: 0,
    fandeckList: [],
    colorList: [],
    productList: [],
    baseList: [],
    serviceDepartmentList: []
};

/*
 * Structure of ticketing store:
 * - tickets {Array}                - list of tickets
 * - ticketsCount {Number}          - total number of tickets
 * - newTicketsCount {Number}       - number of answered tickets
 * - serviceDepartmentList {Array}  - list of service departments from connected TMC
 */
export const ticketingReducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.TICKETING_TAB_INIT:
            return initialState;
        case actionTypes.SAVE_TICKETS:
            return {
                ...state,
                tickets: action.payload.tickets,
                ticketsCount: action.payload.count
            };
        case actionTypes.TICKETS_INCREASE_NEW_NOTIFICATION_COUNT:
            return {
                ...state,
                newTicketsCount: state.newTicketsCount + 1
            };
        case actionTypes.TICKETING_SAVE_FANDECK_LIST:
            return {
                ...state,
                fandeckList: action.payload.fandeckList
            };
        case actionTypes.TICKETING_SAVE_COLOR_LIST:
            return {
                ...state,
                colorList: action.payload.colorList
            };
        case actionTypes.TICKETING_SAVE_PRODUCT_LIST:
            return {
                ...state,
                productList: action.payload.productList
            };
        case actionTypes.TICKETING_SAVE_BASE_LIST:
            return {
                ...state,
                baseList: action.payload.baseList
            };
        case actionTypes.TICKETING_SAVE_SERVICE_DEPARTMENTS:
            return {
                ...state,
                serviceDepartmentList: action.payload.serviceDepartmentList
            };
        case actionTypes.MENU_ADD_NEW_TICKETING_TAB:
            return {
                ...state,
                newTicketsCount: 0
            };
        case actionTypes.CLOSE_ACTIVE_TAB:
        case actionTypes.CLOSE_ALL_TABS_EXCEPT_ACTIVE:
        case actionTypes.CLOSE_ALL_TABS:
            let tab;
            for (tab of action.payload.newTabList) {
                if (tab.type === types.TICKETING_TAB) {
                    return state;
                }
            }

            return initialState;
        case actionTypes.LOG_OUT_SUCCESS:
        case actionTypes.WEBSOCKET_CLOSED:
        case actionTypes.DATABASE_CHANGE:
            return initialState;
        default:
            return state;
    }
};
